import { useMatches } from 'react-router';
import type { RouteHandle } from '../router/route-handle';

type Crumb = {
  readonly id: string;
  /** An English key, translated where it is rendered. */
  readonly label: string;
  readonly to: string;
};

function hasCrumb(handle: unknown): handle is RouteHandle {
  return typeof handle === 'object' && handle !== null && 'crumb' in handle;
}

/** The crumbs of the matched route chain, outermost first. */
export function useCrumbs(): Crumb[] {
  return useMatches().flatMap((match) => {
    if (!hasCrumb(match.handle)) return [];
    const { crumb } = match.handle;
    const label = typeof crumb === 'string' ? crumb : crumb(match.params);
    return label ? [{ id: match.id, label, to: match.pathname }] : [];
  });
}
